import React from 'react';
import Team from '../components/Team';
import Contact from '../components/Contact';

function TeamPage() {
  return (
    <div className="page-transition pt-20">
      {/* Page Header */}
      <section className="py-20 bg-gradient-to-br from-yellow-500 to-orange-600 text-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-6xl font-black mb-6">Our Team</h1>
          <p className="text-xl text-yellow-100 max-w-2xl mx-auto">
            Meet the talented professionals who make the magic happen
          </p>
        </div>
      </section>
      
      <Team />
      
      {/* Why Join Us Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-6">
              Why Work With <span className="text-gradient">Us?</span>
            </h2>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center p-6 reveal-element">
              <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center text-green-600 text-2xl mx-auto mb-4">
                <i className="fas fa-rocket"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Growth</h3>
              <p className="text-gray-600">Continuous learning and career development opportunities</p>
            </div>
            
            <div className="text-center p-6 reveal-element" style={{ animationDelay: '0.1s' }}>
              <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center text-blue-600 text-2xl mx-auto mb-4">
                <i className="fas fa-users"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Culture</h3>
              <p className="text-gray-600">Collaborative and inclusive work environment</p>
            </div>
            
            <div className="text-center p-6 reveal-element" style={{ animationDelay: '0.2s' }}>
              <div className="w-16 h-16 bg-purple-100 rounded-2xl flex items-center justify-center text-purple-600 text-2xl mx-auto mb-4">
                <i className="fas fa-laptop-code"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Technology</h3>
              <p className="text-gray-600">Work with cutting-edge technologies and tools</p>
            </div>
            
            <div className="text-center p-6 reveal-element" style={{ animationDelay: '0.3s' }}>
              <div className="w-16 h-16 bg-yellow-100 rounded-2xl flex items-center justify-center text-yellow-600 text-2xl mx-auto mb-4">
                <i className="fas fa-gift"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Benefits</h3>
              <p className="text-gray-600">Competitive salary and comprehensive benefits package</p>
            </div>
          </div>
        </div>
      </section>
      
      <Contact />
    </div>
  );
}

export default TeamPage;